/* src/app/sections/navigation-section/navigation-section.component.css */
/*# sourceMappingURL=navigation-section.component.css.map */
